import { useURL } from "@kalyzee/kast-web-sdk/web-components";
import { ReactElement } from "react";
import { AppNavigate } from "./AppNavigate";
import { getGlobalQuery, NavigateGlobalQuery } from "./queries";

/** Replays-tab sentinel: `?vodId=_` selects the tab without naming a meeting. */
const VOD_ID_TAB_SENTINEL = "_";

interface ListVodRedirectProps {
  /** Rendered when the URL carries no playable vodId (absent or sentinel). */
  fallback: ReactElement;
}

/**
 * /list links carrying `?vodId=<meetingId>` point at a replay their bearer may
 * not be able to open on /list (visitors have no list page; guests must not be
 * logged out for following a replay link). Send them to the standalone
 * /player/:id route, registered in both route trees. Sticky queries carry over
 * via AppNavigate; `vodId` itself is consumed (non-sticky, not forwarded).
 */
const ListVodRedirect = ({ fallback }: ListVodRedirectProps) => {
  const url = useURL();
  const vodId = getGlobalQuery(url.href, NavigateGlobalQuery.VOD_ID);
  if (!vodId || vodId === VOD_ID_TAB_SENTINEL) return fallback;
  return <AppNavigate to={`/player/${encodeURIComponent(vodId)}`} replace />;
};

export default ListVodRedirect;
